import { render, staticRenderFns } from "./tearOrder.vue?vue&type=template&id=36cd7431&scoped=true"
import script from "./tearOrder.vue?vue&type=script&lang=js"
export * from "./tearOrder.vue?vue&type=script&lang=js"
import style0 from "./tearOrder.vue?vue&type=style&index=0&id=36cd7431&prod&lang=scss"
import style1 from "./tearOrder.vue?vue&type=style&index=1&id=36cd7431&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd7431",
  null
  
)

export default component.exports